import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const AcquirerBinsRoutes: Routes = [
  {
    path: "acquirer-bins",
    loadComponent: () =>
      import("./acquirer-bins/acquirer-bins.component").then(
        (m) => m.AcquirerBinsComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./acquirer-bins-list/acquirer-bins-list.component").then(
            (m) => m.AcquirerBinsListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./acquirer-bins-form/acquirer-bins-form.component").then(
            (m) => m.AcquirerBinsFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./acquirer-bins-form/acquirer-bins-form.component").then(
            (m) => m.AcquirerBinsFormComponent,
          ),
      },
    ],
  },
];
